
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M18 2H8a4 4 0 00-4 4v12a4 4 0 004 4h10a2 2 0 002-2V4a2 2 0 00-2-2zM6 6a2 2 0 012-2h10v10H8a3.91 3.91 0 00-2 .56zm2 14a2 2 0 010-4h10v4zm2-12h4a1 1 0 000-2h-4a1 1 0 000 2z"}})])
          )
        }
      }
    